<template>
    <div>
        <q-modal v-model="add_question" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" @show="clearQuestions()" @hide="hideQuestionModal()" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="hideQuestionModal()" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('question') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row gutter-sm">
                        <div class="col-xs-12 col-sm-12">
                            <q-select v-model="webcast_evaluation_question_type" :options="test_types.map(e => ({ label: $t(e.slug), value: e.value }))" :float-label="$t('question_type')" :error="$v.webcast_evaluation_question_type.$error" @input="$v.webcast_evaluation_question_type.$touch" />
                        </div>

                        <div class="col-xs-12 col-sm-12">
                            <q-field :count="256">
                                <q-input v-model="title" :float-label="$t('title')" :error="$v.title.$error" @input="$v.title.$touch" />
                            </q-field>
                        </div>
                    </div>

                    <div class="row gutter-sm justify-end q-mt-lg">
                        <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                            <q-btn color="tertiary" class="full-width" :label="$t('cancel')" icon="far fa-block" @click="hideQuestionModal()" />
                        </div>

                        <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                            <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveQuestion()" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, requiredIf, maxValue, minValue, maxLength } from 'vuelidate/lib/validators'

export default {
    props: ['id_webcast', 'id_test', 'id_question', 'add_question', 'test_types'],

    i18nOptions: { namespaces: [ 'custom', 'common', 'training', 'admin'] },

    data() {
        return {
            title: '',
            webcast_evaluation_question_type: ''
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        loadQuestion() {
            this.$q.loading.show()

            this.$axios.get(`/admin_webcasts/webcasts/${this.id_webcast}/webcast_evaluations/${this.id_test}/webcast_evaluation_questions/${this.id_question}/`, this.getHeader)
            .then(response => {
                this.title = response.data.title
                this.webcast_evaluation_question_type = response.data.webcast_evaluation_question_type

                this.$q.loading.hide()
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        saveQuestion() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let data = {
                    'title': this.title,
                    'webcast_evaluation_question_type': this.webcast_evaluation_question_type
                }

                if (this.id_question != 0) {
                    this.$axios.put(`/admin_webcasts/webcasts/${this.id_webcast}/webcast_evaluations/${this.id_test}/webcast_evaluation_questions/${this.id_question}/`, data, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()
                        this.$v.$reset()

                        this.$q.notify({
                            message: this.$t('question_edit_success'),
                            type: 'positive',
                            icon: 'fal fa-save'
                        })

                        this.hideQuestionModal()
                    })
                    .catch(e => {
                        this.$q.loading.hide()

                        this.$q.notify({
                            message: this.$t('question_edit_error'),
                            type: 'negative',
                            icon: 'fal fa-ban'
                        })

                        console.log(e)
                    })
                }
                else {
                    this.$axios.post(`/admin_webcasts/webcasts/${this.id_webcast}/webcast_evaluations/${this.id_test}/webcast_evaluation_questions/`, data, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()
                        this.$v.$reset()

                        this.$q.notify({
                            message: this.$t('question_add_success'),
                            type: 'positive',
                            icon: 'fal fa-save'
                        })

                        this.hideQuestionModal()
                    })
                    .catch(e => {
                        this.$q.loading.hide()

                        this.$q.notify({
                            message: this.$t('question_add_error'),
                            type: 'negative',
                            icon: 'fal fa-ban'
                        })

                        console.log(e)
                    })
                }
            }
        },

        clearQuestions() {
            this.$v.$reset()
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        hideQuestionModal() {
            this.title = ''
            this.webcast_evaluation_question_type = ''
            this.$v.$reset()

            this.$emit('returnToQuestions', '')
        }
    },

    watch: {
        id_question: function() {
            if (this.id_question != 0) this.loadQuestion()
        }
    },

    created() {

    },

    validations() {
        return {
            title: { required, maxLength: maxLength(256)},
            webcast_evaluation_question_type: { required },
        }
    }
}
</script>

<style>

</style>
